import axios from "axios";
import { errorToast, successToast } from "./globalFunctions";

axios.defaults.headers.common["Accept"] = "application/json";
axios.interceptors.request.use(
  (config) => {
    const user = window.localStorage.getItem("user")
      ? JSON.parse(window.localStorage.getItem("user"))
      : null;
    let token = user?.token ?? "";

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  (response) => {
    if (response.data) {
      if (response.data.message) {
        successToast(response.data.message);
      }
    }
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 401) {
        errorToast(
          "Хандах эрхийн хугацаа дууссан байна. Дахин нэвтэрч орно уу !"
        );

        window.location.href = "/auth?isTokenExpired=true";
      } else {
        errorToast(data.message || "Something went wrong");
      }
    } else if (error.request) {
      errorToast("Серверт холбогдох боломжгүй байна. Сүлжээгээ шалгана уу.");
    }

    if (error.response && error.response.data && error.response.data.message) {
      return Promise.reject(new Error(error.response.data.message));
    }
    return Promise.reject(error);
  }
);
